import { GET_SERVICE_SEARCH_DEVICE_SUCCESS } from "../actions/servicesAction"


const procedureReducer = (state = [], { type,  payload=[] }) => {
    switch (type) {
      case GET_SERVICE_SEARCH_DEVICE_SUCCESS:
        return getOptionFilter(payload)
      default:
        return state
    }
  }
  
  export default procedureReducer


const getOptionFilter = (data)=>{
    let option = {}
    if(data){
      data.map(item => {
      let deviceOption = {}
      if(item?.name_of_service){
          deviceOption = {
          [item.name_of_service] :{
            label: item.name_of_service,
            value: item.name_of_service
          }
        }
      }
      option = {
        ...option,
        ...deviceOption
      }
      return option
    })
  }
    return {
      ...option,
      "addNewProcedure": {
        label: "Add “New Procedure”",
        value: "addNewProcedure"
      }
    }
  }